define([
    "dojo/_base/declare",
    "csi/prefs",
    "csi/xml",
    "csi/action/Controller"
], function(declare,csiPrefs,xml,Controller) {

    return declare(Controller,
        {

            toWriterRequest: function() {
                // summary: write special request to server passing custom View Key
            	var state = (this.m_action.m_id == "ORToPending" ? "Pending" : "Approved");
                var customViewKey = csiPrefs.composeKey(this.widget.getViewPreferenceKey(), null, state);
                return this.inherited(arguments)
                        .addParameter("CustomViewKey", xml.ATTR_STRING, customViewKey);

            }
        }
    );

});